import { cn as classname } from '@bem-react/classname';

export const cnPageHeader = classname('PageHeader');
